export const TRANSITIONS = {
  overlay: {
    enterFromClass: 'opacity-0 scale-75',
    enterActiveClass: 'transition-transform transition-opacity duration-150 ease-in',
    leaveActiveClass: 'transition-opacity duration-150 ease-linear',
    leaveToClass: 'opacity-0',
  },
  toggleable: {
    timeout: 500,
    classNames: {
      enter: 'max-h-0',
      enterActive: '!max-h-[1000px] overflow-hidden transition-[max-height] duration-500 ease-in',
      exit: 'max-h-[1000px]',
      exitActive: '!max-h-0 overflow-hidden transition-[max-height] duration-450 ease-out',
    },
  },
}
